import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/features/login/LoginView.vue";
import PoolsView from "@/features/pools/PoolsView.vue";
import AuthShell from "@/features/login/AuthShell.vue";
import OutView from "@/features/out/OutView.vue";
import PoolShell from "@/features/pool/PoolShell.vue";
import PoolView from "@/features/pool/PoolView.vue";
import ProbeView from "@/features/probe/ProbeView.vue";
import LogoutView from "@/features/login/LogoutView.vue";
import ProfileView from "@/features/profile/ProfileView.vue";
import ProbeShell from "@/features/probe/ProbeShell.vue";
import ProbeHistoryView from "@/features/probe/ProbeHistoryView.vue";
import SidebarShell from "@/shared/components/SidebarShell.vue";
import MapView from "@/features/map/MapView.vue";
import NotesView from "@/features/notes/NotesView.vue";
import AlertsView from "@/features/alerts/AlertsView.vue";
import UnregisterView from "@/features/unregister/UnregisterView.vue";
import BlePublicView from "@/features/ble/public/BlePublicView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: "/unregister", component: UnregisterView },
    {
      path: "/login",
      component: LoginView,
    },
    {
      path: "/logout",
      component: LogoutView,
    },
    {
      path: "/ble",
      component: BlePublicView,
    },
    {
      path: "/",
      component: AuthShell,
      children: [
        { path: "", component: PoolsView },
        {
          path: "",
          component: SidebarShell,
          children: [
            {
              path: "pool/:poolId",
              component: PoolShell,
              children: [
                { path: "", component: PoolView },
                {
                  path: "probe/:probeIdx",
                  component: ProbeShell,
                  children: [
                    {
                      path: "",
                      component: ProbeView,
                    },
                    {
                      path: "history",
                      component: ProbeHistoryView,
                    },
                  ],
                },
                {
                  path: "out/:outIdx",
                  component: OutView,
                },
                {
                  path: "alerts",
                  component: AlertsView,
                },
              ],
            },
            {
              path: "map",
              component: MapView,
            },
            {
              path: "notes",
              component: NotesView,
            },
            {
              path: "profile",
              component: ProfileView,
            },
          ],
        },
      ],
    },
  ],
  scrollBehavior: (to, from, savedPosition) =>
    savedPosition ?? {
      top: 0,
    },
});

export default router;
